import React from "react";

import clubLogo from "../../assets/ClubLogo.png";
import header2 from "../../assets/header2.png";
import header3 from "../../assets/header3.png";
import devonMap from "../../assets/Jampot/devon_map.png";
import { styles as s } from "../styles";

const closedPanel = {
  ...s.card,
  padding: 22,
  display: "grid",
  gap: 14,
  textAlign: "center",
};

const title = {
  margin: 0,
  fontSize: "clamp(2rem, 5vw, 3.4rem)",
  fontWeight: 950,
  letterSpacing: 0,
  color: "#231b16",
};

const intro = {
  margin: "0 auto",
  maxWidth: 680,
  color: "#4f4338",
  fontSize: "1.05rem",
  lineHeight: 1.55,
};

const infoGrid = {
  display: "grid",
  gap: 10,
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  marginTop: 6,
  textAlign: "left",
};

const infoBox = {
  background: "rgba(255,255,255,0.7)",
  border: "1px solid rgba(47,35,26,0.14)",
  borderRadius: 12,
  padding: 14,
};

const infoLabel = {
  color: "#7c4a2d",
  fontSize: 12,
  fontWeight: 900,
  letterSpacing: 0,
  marginBottom: 4,
  textTransform: "uppercase",
};

export default function BookingClosed({ onNavigate, mode = "booking" }) {
  const isManage = mode === "manage";

  return (
    <div
      style={{
        ...s.pageWrap,
        backgroundImage: `url(${devonMap})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div style={{ ...s.pageWatermark, backgroundImage: `url(${clubLogo})` }} />

      <button type="button" onClick={() => onNavigate("jampot")} style={s.backLink}>
        Back to rally page
      </button>

      <div style={s.page}>
        <div style={s.brandBar}>
          <div style={s.brandHero}>
            <picture>
              <source media="(max-width: 640px)" srcSet={header3} />
              <img src={header2} alt="Jampot Rally 2026 header" style={s.brandHeroImg} />
            </picture>
          </div>
        </div>

        <section style={closedPanel}>
          <div style={infoLabel}>Jampot Rally 2026</div>
          <h1 style={title}>Bookings are now closed</h1>
          <p style={intro}>
            The rally is now underway, so online {isManage ? "booking amendments" : "bookings"} are no longer
            available. Please speak to reception on site if you need help with an existing booking.
          </p>

          <div style={infoGrid}>
            <div style={infoBox}>
              <div style={infoLabel}>Reception</div>
              <div style={{ fontWeight: 900 }}>Please check in on arrival</div>
              <div style={{ marginTop: 4, color: "#5c5148" }}>
                The team at rally reception can help with booking questions during opening hours.
              </div>
            </div>
            <div style={infoBox}>
              <div style={infoLabel}>Need rally info?</div>
              <div style={{ fontWeight: 900 }}>Routes, food and local services</div>
              <div style={{ marginTop: 4, color: "#5c5148" }}>
                The rally page has the latest practical information for the weekend.
              </div>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
            <button type="button" style={{ ...s.btn, minWidth: 180 }} onClick={() => onNavigate("jampot")}>
              Rally information
            </button>
            <button type="button" style={{ ...s.btn, minWidth: 180, borderColor: "#555" }} onClick={() => onNavigate("home")}>
              Back to site
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
